// extracted by mini-css-extract-plugin
export default {"root":"Chevron_root__xZsMq","arrow":"Chevron_arrow__fmi9-"};